import { Component, OnInit, ViewEncapsulation, Input, Inject } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from "@angular/forms";
import { GeoFilter, GeoFilterNext } from "../../../../shared/interface/geosite";
import { GeoSegments } from "../../../../shared/interface/site";
import { GroupService } from "../../../../shared/services/group/group.service";
import { WidgetService } from "../../../../shared/services/widget/widget.service";
import { SiteService } from "../../../../shared/services/site/site.service"
import { CommonService } from '../../../../shared/services/common/common.service';
import { MAT_DIALOG_DATA } from "@angular/material";
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
// import { MatStepper } from '@angular/material';
declare var L: any;

@Component({
  selector: 'geo-map',
  templateUrl: './geo-map.component.html',
  styleUrls: ['./geo-map.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GeoMapComponent implements OnInit {
  @Input('graphData') graphData: any;
  @Input('segmentData') segmentData: any;
  @Input('widgetHeight') widgetHeight: any;
  widgetId = "";
  private map;
  latlngs: any = [];
  geoConfig: any = null;
  heatDataObj: any = [];
  geoMessage: any = "";
  editableLayers: any = null;


  constructor(private groupService: GroupService) { }

  private initMap(): void {
    var container = L.DomUtil.get('geoMap' + this.widgetId);
    if (container != null) {
      container._leaflet_id = null;
    }
    this.map = new L.map('geoMap' + this.widgetId, {
      fullscreenControl: true,
      center: [25.13339, 55.23432],
      zoom: 15,
      markerZoomAnimation: false,
      preferCanvas: true
    });
  }

  ngOnInit() {
    this.widgetId = this.graphData.udf.widgetId;

    if (this.graphData.udf && this.graphData.udf.geoConfig && this.graphData.udf.geoConfig[0] != null)
      this.geoConfig = this.graphData.udf.geoConfig[0];
  }

  reSizeMapHeight() {
    this.groupService.getAction().subscribe(data => {
      if (["reSizeMapHeight"].includes(data.action)) {
        var container = L.DomUtil.get('mapcontainer' + data.data.widgetId);
        if (container != null) {
          if (data.data.height) {
            container["style"]["height"] = data.data.height - 118 + 'px';
            this.map.invalidateSize();
          }
        }
      }
    });
  }

  ngAfterViewInit() {
    var that = this;
    this.initMap();
    that.editableLayers = new L.FeatureGroup();
    that.map.addLayer(this.editableLayers);
    var container = L.DomUtil.get('mapcontainer' + this.widgetId);
    if (container != null) {
      if (this.widgetHeight) {
        container["style"]["height"] = this.widgetHeight - 118 + 'px';
        this.map.invalidateSize();
      }
    }
    this.reSizeMapHeight();
    const googleStreets = L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
      maxZoom: 25,
      maxNativeZoom: 20,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
    });
    googleStreets.addTo(this.map);
    let markersCluster = L.markerClusterGroup({
      spiderfyOnMaxZoom: false,
      showCoverageOnHover: false,
      zoomToBoundsOnClick: true
    });

    if (this.graphData && this.graphData.dataFilter.length > 0) {
      this.graphData.dataFilter.forEach(loc => {
        // let segIds = [];
        // let segGenders = [];
        // let segIdGroupData = '';
        // let maleCount = 0;;
        // let femaleCount = 0;
        // loc.data.map(function (el) {
        //    // if (el.SegID) {
        //   //   el.SegID.forEach(e => {
        //   //     segIds.push(e);
        //   //   });
        //   // }
        //   if (el.gender)
        //     segGenders.push(el.gender);
        // });
        // segIds = this.groupBy(segIds, '');
        // segGenders = this.groupBy(segGenders, '');
        // Object.keys(segIds).forEach(el => {
        //   this.segmentData.filter(function (itm: any) {
        //     if (itm.segId == el) {
        //       segIdGroupData += '<span><b>' + itm.segmentLevel1 + "::" + itm.segmentLevel2 + "::" + itm.segmentLevel3 + "::" + itm.segementName + '</b> = ' + segIds[el].length + '</span>';
        //     }
        //   });
        // });
        // Object.keys(segGenders).forEach(el => {
        //   if (el.toLocaleLowerCase() === "male")
        //     maleCount = segGenders[el].length;
        //   else if (el.toLocaleLowerCase() === "female")
        //     femaleCount = segGenders[el].length;
        // });
        // this.geoMessage = '<div class="tpheading">' + loc.label + '</div> <div class="tpgenders"><b>Total Footfall = </b> ' + loc.data.length + ', <b>Male = </b> ' + maleCount +
        //   ', <b>Female = </b> ' + femaleCount + ', <b>Un-identified = </b> ' + (loc.data.length - maleCount - femaleCount) + '</div> ';

        if (this.geoConfig && this.geoConfig.locationType == "customlocation") {
          if (this.geoConfig.drawMapType === GeoFilterNext.geoRadius) {
            var myIcon = L.icon({
              iconUrl: "../../../../../../assets/leaflet/img/marker-icon.png",
              iconSize: [20, 30],
              shadowSize: [50, 64],
              iconAnchor: [8, 29],
              shadowAnchor: [4, 62],
              popupAnchor: [-3, -76]
            });
            if (loc.siteLoc.length > 0 || loc.siteLoc.lat) {
              var markerJson = {
                type: "Point",
                coordinates: [loc.siteLoc.lng, loc.siteLoc.lat]
              };
              var marker = L.geoJSON(markerJson, {
                onEachFeature: function (feature, layer) {
                  //layer.bindPopup(that.geoMessage);
                  layer.setIcon(myIcon);
                }
              }).addTo(this.map);
              var circle = L.circle(loc.siteLoc, {
                color: "#ff5050",
                fillColor: "#ff5050",
                fillOpacity: 0.5,
                radius: this.geoConfig.radius * 1609.34
              }).addTo(this.map);
              //circle.bindPopup(that.geoMessage);
              this.latlngs.push({ "name": loc.label, "view": marker.getBounds().getCenter() });
            }
          } else if (this.geoConfig.drawMapType === GeoFilterNext.drawSite) {
            if (this.geoConfig.geoLatLng != null) {
              var layer = L.geoJSON(that.geoConfig.geoLatLng, { fillColor: '#ff5050', color: '#ff5050', maxWidth: 450 }).addTo(that.editableLayers);
              this.latlngs.push({ "name": loc.label, "view": layer.getBounds().getCenter() });
            }
          } else
            this.latlngs.push({ "name": loc.label });
        } else {
          if (loc.siteLoc && loc.siteLoc.coordinates && loc.siteLoc.coordinates.length > 0) {
            let site = L.geoJSON(loc.siteLoc, {
              // onEachFeature: function (feature, layer) {
              //   layer.bindPopup(that.geoMessage);
              // },
              fillColor: '#ff5050', color: '#ff5050', maxWidth: 450
            }).addTo(this.map);
            this.latlngs.push({ "name": loc.label, "view": site.getBounds().getCenter() });
          } else
            this.latlngs.push({ "name": loc.label });
        }

        if (loc.data.length > 0) {
          let dataAry: any = [];
          loc.data.forEach(point => {
            if (this.geoConfig && this.geoConfig.mapType == "heatMap") {
              this.heatDataObj.push([point.location.coordinates[1], point.location.coordinates[0]]);
            } else {
              L.circleMarker([point.location.coordinates[1], point.location.coordinates[0]], {
                color: '#3388ff',
                radius: 5
              }).addTo(markersCluster);
            }
          });
        }
      });
      if (this.geoConfig && this.geoConfig.mapType == "heatMap") {
        var heat = L.heatLayer(this.heatDataObj, {
          minOpacity: 0.5,
          radius: 20,
          blur: 50,
          maxZoom: 7,
          max: 4,
          // gradient: {
          //   0: this.geoConfig ? this.geoConfig.filter00Color : "#059505",
          //   0.25: this.geoConfig ? this.geoConfig.filter30Color : "#bdbd05",
          //   0.75: this.geoConfig ? this.geoConfig.filter60Color : "#d18904"
          // }
        }).addTo(this.map);
      } else
        this.map.addLayer(markersCluster);

      if (this.latlngs.length > 0 && this.latlngs[0].view)
        this.map.setView(this.latlngs[0]["view"], 16);
    }
  }

  groupBy(objectArray: any, property: any) {
    return objectArray.reduce((acc, obj) => {
      const key = property ? obj[property] : obj;
      if (!acc[key]) {
        acc[key] = [];
      }
      // Add object to list for given key's value
      acc[key].push(obj);
      return acc;
    }, {});
  }

  setSiteInToView(data: any) {
    this.map.setView(data, 16);
  }

  ngOnDestroy() {
    this.map.off();
    this.map.remove();
  }
}

@Component({
  selector: "geofilter-dialog",
  templateUrl: "geofilter.dialog.html"
})
export class GeoFilterDialog {
  geofiltereForm: FormGroup;
  private map;
  isGeoMarker: boolean = false;
  geoCircle: any = null;
  geoSiteList: any = [];
  geoLatLng: any = null;
  geoFilterType: any = "";
  protected _onDestroy = new Subject<void>();
  protected geoSegments: GeoSegments[] = [];
  public segmentsList: ReplaySubject<GeoSegments[]> = new ReplaySubject<GeoSegments[]>(1);
  public segFilterCtrl: FormControl = new FormControl();
  isSubmitted: number = 0;
  title: any = "Select a Geo-site Type";
  step: any = "Step 1 of 8";
  currentQuestion: any = "locationType";
  lastQuestion: any = "locationType";
  geoNextPr: any = GeoFilterNext;
  editableLayers: any = null;
  currentAdd: any = null;
  drawMessage: string = "";
  isEditQuestion: boolean;
  geoSiteName: string = "";
  segmentName: string = "";
  fromDate: any = "";
  toDate: any = "";
  isExistQuestion: boolean = false;
  isHideSavedQuestion: boolean = false;
  savedGeoObj: any = null;
  // @ViewChild('stepper') private myStepper: MatStepper;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private groupService: GroupService,
    private widgetService: WidgetService,
    private siteService: SiteService,
    private commonService: CommonService,
    private fb: FormBuilder,) {
    this.BindAllGeoSites();
  }
  ngOnInit() {
    this.geoFilterType = this.data.geoFilterType;
    this.getSegmentsList();
    if (this.data.listQuestion && this.data.listQuestion.length == 0) {
      this.isEditQuestion = false;
      this.isHideSavedQuestion = true;
    } else if (this.data.isEdit) {
      this.isHideSavedQuestion = true;
      this.isEditQuestion = true;
      this.currentQuestion = GeoFilterNext.saveType;
      this.savedGeoObj = this.data;
    }
    this.createForm(this.data);

  }

  createForm(data: GeoFilter) {
    this.geofiltereForm = this.fb.group({
      savedQuestionType: [(data.savedQuestionType ? data.savedQuestionType : "")],
      savedQuestion: [(data.savedQuestion ? data.savedQuestion : "")],
      locationType: [(data.locationType ? data.locationType : "")],
      visitOperator: [data.visitOperator ? data.visitOperator : "equal"],
      visit: [data.visit ? data.visit : ""],
      ageRange: [data.ageRange ? data.ageRange : ""],
      age: [data.age ? data.age : ""],
      ageOperator: [data.ageOperator ? data.ageOperator : "equal"],
      visitRange: [data.visitRange ? data.visitRange : ""],
      filterFromDate: [data.filterFromDate ? data.filterFromDate : ""],
      filterToDate: [data.filterToDate ? data.filterToDate : ""],
      radius: [data.radius ? data.radius : ""],
      segOpt: [data.segOpt ? data.segOpt : "or"],
      geoSite: [data.geoSite ? data.geoSite : ""],
      segId: [(data.segId && data.segId.length > 0 ? data.segId : [])],
      drawMapType: [data.drawMapType ? data.drawMapType : ""],
      ageType: [data.ageType ? data.ageType : ""],
      segmentType: [data.segmentType ? data.segmentType : ""],
      visitType: [data.visitType ? data.visitType : ""],
      saveType: [data.saveType ? data.saveType : ""],
      questionName: [data.questionName ? data.questionName : ""],
    });


    this.geofiltereForm.get('ageOperator').valueChanges.subscribe((type: string) => {
      if (type === 'between' || type === 'or') {
        this.setValidation('ageRange');
      } else {
        this.removeValidation('ageRange');
      }
    });

    this.geofiltereForm.get('visitOperator').valueChanges.subscribe((type: string) => {
      if (type === 'between') {
        this.setValidation('visitRange');
      } else {
        this.removeValidation('visitRange');
      }
    });

    if (this.isEditQuestion) {
      this.geoLatLng = this.data.geoLatLng;
      if (this.data.drawMapType == GeoFilterNext.drawSite && this.data.geoLatLng) {
        this.setMap(data.radius, true);
      }
      if (this.data.drawMapType == GeoFilterNext.geoRadius && this.data.geoLatLng) {
        this.setValidation('radius');
        this.setMap(data.radius, false);
      }
    }
  }

  onSavedQuestion() {
    if (this.geofiltereForm.get('savedQuestionType').value == 'askQuestion')
      this.isHideSavedQuestion = true;
  }

  onDeleteQuestion(id: any, isDelete) {
    if (isDelete) {
      if (
        confirm(
          "Are you sure you want to remove this question"
        ) == false
      ) {
        return false;
      }
      this.widgetService.deleteQuestion(id).subscribe(
        res => {
          let deleteQut = [];
          this.data.listQuestion.filter(function (el) {
            if (el._id !== id)
              deleteQut.push(el);
          });
          this.data.listQuestion = deleteQut;
          if (this.data.listQuestion && this.data.listQuestion.length > 0) {
            this.isHideSavedQuestion = false;
          } else {
            this.isHideSavedQuestion = true;
            this.isEditQuestion = false;
          }
        });
    } else {
      this.isHideSavedQuestion = true;
      this.isEditQuestion = true;
      this.currentQuestion = GeoFilterNext.saveType;
      this.savedGeoObj = this.data.listQuestion.find(x => x._id == id).geoConfig;
      this.createForm(this.savedGeoObj);
      if (this.savedGeoObj.drawMapType == GeoFilterNext.drawSite && this.savedGeoObj.geoLatLng) {
        this.geoLatLng = this.savedGeoObj.geoLatLng;
        this.setMap(this.savedGeoObj.radius, true);
      }
      if (this.savedGeoObj.drawMapType == GeoFilterNext.geoRadius && this.savedGeoObj.geoLatLng) {
        this.geoLatLng = this.savedGeoObj.geoLatLng;
        this.setValidation('radius');
        this.setMap(this.savedGeoObj.radius, false);
      }
      this.savedGeoObj.questionId = id;
    }
  }

  private initMap(): void {
    var container = this.isEditQuestion ? L.DomUtil.get("editChartMap") : L.DomUtil.get("chartMap");
    if (container != null) {
      container._leaflet_id = null;
    }
    this.map = new L.Map(this.isEditQuestion ? "editChartMap" : "chartMap", {
      center: [25.13339, 55.23432],
      zoom: 15,
      markerZoomAnimation: false,
      zoomControl: false,
      preferCanvas: true
    });
  }

  BindAllGeoSites() {
    if (localStorage.getItem("getSitesdsxcmt")) {
      this.geoSiteList = JSON.parse(atob(localStorage.getItem("getSitesdsxcmt")));
    }
  }

  setMap(radius: any, isdraw: boolean) {
    let marker: any = null;
    var myIcon = L.icon({
      iconUrl: "../../../assets/leaflet/img/marker-icon.png",
      iconSize: [20, 30],
      shadowSize: [50, 64],
      iconAnchor: [8, 29],
      shadowAnchor: [4, 62],
      popupAnchor: [-3, -76]
    });
    var that = this;
    setTimeout(() => {
      this.initMap();
      if (isdraw) {
        that.editableLayers = new L.FeatureGroup();
        that.map.addLayer(this.editableLayers);
        that.map.addControl(new L.Control.Draw({
          edit: {
            featureGroup: that.editableLayers,
            poly: {
              allowIntersection: false
            },
            remove: false,
            edit: false
          },
          draw: {
            polyline: false,
            polygon: true,
            rectangle: true,
            marker: false,
            circle: false,
            circlemarker: false
          }
        }));
        L.control.zoom({
          position: 'bottomright'
        }).addTo(this.map);

        if (that.currentAdd != null)
          that.editableLayers.addLayer(that.currentAdd);

        that.map.on('draw:drawstart', function (e) {
          if (that.currentAdd)
            that.map.removeLayer(that.currentAdd);
          that.isGeoMarker = false;
          that.drawMessage = "";
        });
        that.map.on(L.Draw.Event.CREATED, function (event: any) {
          that.currentAdd = event.layer;
          that.geoLatLng = event.layer;
          that.editableLayers.addLayer(event.layer);
        });
        if (this.savedGeoObj && this.savedGeoObj.drawMapType === GeoFilterNext.drawSite && this.isEditQuestion) {
          var lLayer = L.geoJSON(that.savedGeoObj.geoLatLng, { fillColor: '#ff5050', color: '#ff5050', maxWidth: 450 }).addTo(that.editableLayers);
          this.map.eachLayer((layer) => {
            if (layer instanceof L.Polygon || layer instanceof L.Rectangle) {
              that.currentAdd = layer;
            }
          });
          if (lLayer)
            this.map.setView(lLayer.getBounds().getCenter(), 16);
        }
      }
      const googleStreets = L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
        maxZoom: 25,
        maxNativeZoom: 20,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
      });
      googleStreets.addTo(that.map);
      if (!isdraw) {
        $(function () {
          $('body .leaflet-draw-draw-polygon').remove();
          $('body .leaflet-draw-draw-rectangle').remove();
        });
        if (that.geoLatLng != null && that.geoLatLng != '' && this.data.drawMapType === GeoFilterNext.geoRadius) {
          marker = new L.marker(that.geoLatLng, { icon: myIcon }).addTo(that.map);
          that.radiusChange(that.geofiltereForm.get('radius').value);
        }
        $(function () {
          that.map.on('click', addMarker);
          function addMarker(e: any) {
            if (marker != null) {
              that.map.removeLayer(marker);
            };
            that.isGeoMarker = false;
            that.drawMessage = "";
            that.geoLatLng = e.latlng;
            that.radiusChange(that.geofiltereForm.get('radius').value);
            marker = new L.Marker(e.latlng, { icon: myIcon }).addTo(that.map);
            // marker.bindPopup("This is the test").openPopup();
          }
        });
      }
      if (isdraw) {
        $(function () {
          $('body #mapsidenav-expand').remove();
          $('body #mapsidenav-add').remove();
        });
      }
    }, 100);
  }

  radiusChange(value: any) {
    if (this.geoCircle != null) {
      this.map.removeLayer(this.geoCircle);
      this.geoCircle = null;
    }
    if (this.geoLatLng && value) {
      value = (value * 1609.34);
      this.geoCircle = L.circle(this.geoLatLng, {
        color: "#ff5050",
        fillColor: "#ff5050",
        fillOpacity: 0.5,
        radius: value
      }).addTo(this.map);
    }
  }

  showFileterMap(filterType: any) {
    if (filterType == "customlocation") {
      this.geofiltereForm.get('geoSite').setValue("");
      this.setMap(null, false);
    }
  }

  getSegmentsList() {
    if (localStorage.getItem("getSegsdsxcmt")) {
      this.geoSegments = JSON.parse(atob(localStorage.getItem("getSegsdsxcmt")));
      this.segmentsList.next(this.geoSegments.slice());
      this.segFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterBanksMulti();
        });
    }
  }
  protected filterBanksMulti() {
    if (!this.geoSegments) {
      return;
    }
    // get the search keyword
    let search = this.segFilterCtrl.value;
    if (!search) {
      this.segmentsList.next(this.geoSegments.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.segmentsList.next(
      this.geoSegments.filter(seg => seg.segementName.toLowerCase().indexOf(search) > -1)
    );
  }

  setValidation(control: any) {
    this.geofiltereForm.get(control).setValidators([Validators.required]);
    this.geofiltereForm.get(control).updateValueAndValidity();
    return !this.geofiltereForm.valid ? true : false;
  }

  removeValidation(control: any) {
    this.geofiltereForm.get(control).clearValidators();
    this.geofiltereForm.get(control).updateValueAndValidity();
  }

  onChange(cQues: any) {
    if (cQues === GeoFilterNext.ageType && this.geofiltereForm.get('ageType').value == 'no') {
      this.removeValidation('age');
      this.removeValidation('ageOperator');
      this.removeValidation('ageRange');
    } else if (cQues === GeoFilterNext.ageType && this.geofiltereForm.get('ageType').value == 'yes') {
      this.setValidation('age');
      this.setValidation('ageOperator');
    } else if (cQues === GeoFilterNext.segmentType && this.geofiltereForm.get('segmentType').value == 'no') {
      this.removeValidation('segOpt');
      this.removeValidation('segId');
    } else if (cQues === GeoFilterNext.segmentType && this.geofiltereForm.get('segmentType').value == 'yes') {
      this.setValidation('segOpt');
      this.setValidation('segId');
    } else if (cQues === GeoFilterNext.visitType && this.geofiltereForm.get('visitType').value == 'no') {
      this.removeValidation('visitOperator');
      this.removeValidation('visit');
      this.removeValidation('visitRange');
    } else if (cQues === GeoFilterNext.visitType && this.geofiltereForm.get('visitType').value == 'yes') {
      this.setValidation('visitOperator');
      this.setValidation('visit');
    } else if (cQues === GeoFilterNext.saveType && this.geofiltereForm.get('saveType').value == 'no') {
      this.removeValidation('questionName');
    } else if (cQues === GeoFilterNext.saveType && this.geofiltereForm.get('saveType').value == 'yes') {
      this.setValidation('questionName');
    }
  }

  onNext(cQues: any) {
    if (!this.geofiltereForm.valid)
      return false;
    // this.myStepper.next();
    if (cQues === GeoFilterNext.locationType && this.geofiltereForm.get('locationType').value === '') {
      this.setValidation('locationType');
      if (!this.geofiltereForm.valid)
        return false;
    } else if (cQues === GeoFilterNext.locationType && this.geofiltereForm.get('locationType').value === GeoFilterNext.geoSite) {
      this.currentQuestion = GeoFilterNext.geoSite;
      this.title = GeoFilterNext.geoSiteTitle;
      this.step = "Step 2 of 8";
    } else if (cQues === GeoFilterNext.locationType && this.geofiltereForm.get('locationType').value === GeoFilterNext.customlocation) {
      this.currentQuestion = GeoFilterNext.drawMapType;
      this.title = GeoFilterNext.drawMapTypeTitle;
      this.step = "Step 2 of 8";
    } else if (cQues === GeoFilterNext.drawMapType && this.geofiltereForm.get('drawMapType').value === '') {
      this.setValidation('drawMapType');
      if (!this.geofiltereForm.valid)
        return false;
    } else if (cQues === GeoFilterNext.drawMapType && this.geofiltereForm.get('drawMapType').value === GeoFilterNext.drawSite) {
      this.currentQuestion = GeoFilterNext.drawMap;
      this.title = GeoFilterNext.drawMapTitle;
      this.step = "Step 2 of 8";
      this.setMap(null, true);
    } else if (cQues === GeoFilterNext.drawMapType && this.geofiltereForm.get('drawMapType').value === GeoFilterNext.geoRadius) {
      this.currentQuestion = GeoFilterNext.geoRadius;
      this.title = GeoFilterNext.geoRadiusTitle;
      this.step = "Step 2 of 8";
      this.setMap(null, false);
    } else if ((cQues === GeoFilterNext.drawMap || cQues === GeoFilterNext.geoRadius || cQues === GeoFilterNext.geoSite)) {
      if (cQues === GeoFilterNext.drawMap) {
        if (this.currentAdd == null) {
          this.isGeoMarker = true;
          this.drawMessage = "Please draw shape";
          return true;
        }
      }
      if (cQues === GeoFilterNext.geoRadius) {
        this.setValidation('radius');
        if (!this.geofiltereForm.valid)
          return false;
        if (this.geoLatLng == null || this.geoLatLng == '') {
          this.isGeoMarker = true;
          this.drawMessage = "Please add marker";
          return true;
        }
      }
      if (cQues === GeoFilterNext.geoSite) {
        this.setValidation('geoSite');
        if (!this.geofiltereForm.valid)
          return false;
        this.geoSiteName = this.geoSiteList.find(x => x._id == this.geofiltereForm.get('geoSite').value).siteName;
      }
      this.currentQuestion = GeoFilterNext.ageType;
      this.title = GeoFilterNext.ageTypeTitle;
      this.step = "Step 3 of 8";
    } else if (cQues === GeoFilterNext.ageType && this.geofiltereForm.get('ageType').value == '') {
      this.setValidation('ageType');
      if (!this.geofiltereForm.valid)
        return false;
    } else if (cQues === GeoFilterNext.ageType && this.geofiltereForm.get('ageType').value) {
      if (this.geofiltereForm.get('ageType').value === "yes") {
        this.setValidation('age');
        this.setValidation('ageOperator');
        if (!this.geofiltereForm.valid)
          return false;
      }
      this.currentQuestion = GeoFilterNext.segmentType;
      this.title = GeoFilterNext.segmentTitle;
      this.step = "Step 4 of 8";
    } else if (cQues === GeoFilterNext.segmentType && this.geofiltereForm.get('segmentType').value === '') {
      this.setValidation('segmentType');
    } else if (cQues === GeoFilterNext.segmentType && this.geofiltereForm.get('segmentType').value) {
      if (this.geofiltereForm.get('segmentType').value === "yes") {
        this.setValidation('segOpt');
        this.setValidation('segId');
        if (!this.geofiltereForm.valid)
          return false;

        let segIds = [];
        this.geofiltereForm.get('segId').value.forEach(seg => {
          var segData = this.geoSegments.find(x => x.segId == seg);
          if (segData)
            segIds.push(segData.segmentLevel1 + '::' + segData.segmentLevel2 + '::' + segData.segmentLevel3 + '::' + segData.segementName);
        });
        if (segIds.length > 0)
          this.segmentName = segIds.join(', ')
      }
      this.currentQuestion = GeoFilterNext.visitType;
      this.title = GeoFilterNext.visitTitle;
      this.step = "Step 5 of 8";
    } else if (cQues === GeoFilterNext.visitType && this.geofiltereForm.get('visitType').value === "") {
      this.setValidation('visitType');
    } else if (cQues === GeoFilterNext.visitType && this.geofiltereForm.get('visitType').value) {
      if (this.geofiltereForm.get('visitType').value === "yes") {
        this.setValidation('visitOperator');
        this.setValidation('visit');
        if (!this.geofiltereForm.valid)
          return false;
      }
      this.currentQuestion = GeoFilterNext.dateType;
      this.title = GeoFilterNext.dateTitle;
      this.step = "Step 6 of 8";
    } else if (cQues === GeoFilterNext.dateType) {
      this.setValidation('filterFromDate');
      this.setValidation('filterToDate');
      if (!this.geofiltereForm.valid)
        return false;
      this.currentQuestion = GeoFilterNext.saveType;
      this.title = GeoFilterNext.saveTitle;
      this.step = "Step 7 of 8";
      this.fromDate = this.commonService.getDateConverted(this.geofiltereForm.get('filterFromDate').value, "YYYY-MM-DD");
      this.toDate = this.commonService.getDateConverted(this.geofiltereForm.get('filterToDate').value, "YYYY-MM-DD");
    } else if (cQues === GeoFilterNext.saveType) {
      this.setValidation('saveType');
      if (!this.geofiltereForm.valid)
        return false;
      if (this.geofiltereForm.get('saveType').value == 'no') {
        this.geofiltereForm.get('questionName').patchValue('');
        this.removeValidation('questionName');
        this.currentQuestion = GeoFilterNext.showAns;
        this.title = GeoFilterNext.showAnsTitle;
        this.step = "Step 8 of 8";
        this.isExistQuestion = false;
      }
      if (this.geofiltereForm.get('saveType').value == 'yes') {
        this.setValidation('questionName');
        if (!this.geofiltereForm.valid)
          return false;
        let data = {
          widgetId: this.data.widgetId,
          questionName: this.geofiltereForm.get('questionName').value
        }
        this.widgetService.existQuestion(data).subscribe(
          res => {
            if (res) {
              this.isExistQuestion = false;
              this.currentQuestion = GeoFilterNext.showAns;
              this.title = GeoFilterNext.showAnsTitle;
              this.step = "Step 8 of 8";
            } else {
              this.isExistQuestion = true;
            }
          });
      }
    }
  }

  onPrevious(cQues: any) {
    // this.myStepper.previous();
    if (cQues === GeoFilterNext.geoSite && this.geofiltereForm.get('locationType').value === GeoFilterNext.geoSite) {
      this.currentQuestion = GeoFilterNext.locationType;
      this.title = GeoFilterNext.locationTypeTitle;
      this.step = "Step 1 of 8";
      this.removeValidation('geoSite');
    } else if (cQues === GeoFilterNext.drawMapType && this.geofiltereForm.get('locationType').value === GeoFilterNext.customlocation) {
      this.currentQuestion = GeoFilterNext.locationType;
      this.title = GeoFilterNext.locationTypeTitle;
      this.step = "Step 1 of 8";
      this.removeValidation('drawMapType');
      this.isGeoMarker = false;
      this.drawMessage = "";
    } else if (cQues === GeoFilterNext.drawMapType && this.geofiltereForm.get('drawMapType').value === GeoFilterNext.drawSite) {
      this.currentQuestion = GeoFilterNext.drawMap;
      this.title = GeoFilterNext.drawMapTitle;
      this.step = "Step 2 of 8";
    } else if (cQues === GeoFilterNext.drawMap && this.geofiltereForm.get('drawMapType').value === GeoFilterNext.drawSite) {
      this.currentAdd = null;
      this.isGeoMarker = false;
      this.drawMessage = "";
      this.currentQuestion = GeoFilterNext.drawMapType;
      this.title = GeoFilterNext.drawMapTypeTitle;
      this.step = "Step 2 of 8";
    } else if (cQues === GeoFilterNext.geoRadius) {
      this.currentQuestion = GeoFilterNext.drawMapType;
      this.title = GeoFilterNext.drawMapTypeTitle;
      this.step = "Step 2 of 8";
      this.isGeoMarker = false;
      this.drawMessage = "";
      this.removeValidation('radius');
    } else if (cQues === GeoFilterNext.ageType && this.geofiltereForm.get('locationType').value === GeoFilterNext.geoSite) {
      this.currentQuestion = GeoFilterNext.geoSite;
      this.title = GeoFilterNext.geoSiteTitle;
      this.step = "Step 2 of 8";
      if (this.geofiltereForm.get('ageType').value === "")
        this.removeValidation('ageType');
      if (this.geofiltereForm.get('ageType').value === "yes") {
        this.removeValidation('age');
        this.removeValidation('ageOperator');
        this.removeValidation('ageRange');
        this.removeValidation('ageType');
      }
    } else if (cQues === GeoFilterNext.ageType && this.geofiltereForm.get('drawMapType').value === GeoFilterNext.drawSite) {
      this.currentQuestion = GeoFilterNext.drawMap;
      this.title = GeoFilterNext.drawMapTitle;
      this.step = "Step 2 of 8";
      this.removeValidation('ageType');
      this.setMap(null, true);
    } else if (cQues === GeoFilterNext.ageType && (this.geofiltereForm.get('locationType').value === GeoFilterNext.customlocation || this.geofiltereForm.get('drawMapType').value === GeoFilterNext.geoRadius)) {
      this.currentQuestion = GeoFilterNext.geoRadius;
      this.title = GeoFilterNext.geoRadiusTitle;
      this.step = "Step 2 of 8";
      this.removeValidation('ageType');
      this.setMap(null, false);
    } else if (cQues === GeoFilterNext.segmentType) {
      if (this.geofiltereForm.get('segmentType').value === "")
        this.removeValidation('segmentType');
      this.currentQuestion = GeoFilterNext.ageType;
      this.title = GeoFilterNext.ageTypeTitle;
      this.step = "Step 3 of 8";
      this.removeValidation('segOpt');
      this.removeValidation('segId');
      this.removeValidation('segmentType');
    } else if (cQues === GeoFilterNext.visitType) {
      this.currentQuestion = GeoFilterNext.segmentType;
      this.title = GeoFilterNext.segmentTitle;
      this.step = "Step 4 of 8";
      if (this.geofiltereForm.get('visitType').value === "")
        this.removeValidation('visitType');
      if (this.geofiltereForm.get('visitType').value === "yes") {
        this.removeValidation('visitOperator');
        this.removeValidation('visit');
        this.removeValidation('visitRange');
        this.removeValidation('visitType');
      }
    } else if (cQues === GeoFilterNext.dateType) {
      this.currentQuestion = GeoFilterNext.visitType;
      this.title = GeoFilterNext.visitTitle;
      this.step = "Step 5 of 8";
      this.removeValidation('filterFromDate');
      this.removeValidation('filterToDate');
    } else if (cQues === GeoFilterNext.saveType) {
      this.currentQuestion = GeoFilterNext.dateType;
      this.title = GeoFilterNext.dateTitle;
      this.step = "Step 6 of 8";
      this.removeValidation('saveType');
      this.removeValidation('questionName');
    } else if (cQues === GeoFilterNext.showAns) {
      this.currentQuestion = GeoFilterNext.saveType;
      this.title = GeoFilterNext.saveTitle;
      this.step = "Step 7 of 8";
    }
  }

  onMapTypeChange() {
    if (this.map != null) {
      this.map.off();
    }
    if (this.geofiltereForm.get('drawMapType').value == GeoFilterNext.drawSite) {
      this.setMap(null, true);
    } else if (this.geofiltereForm.get('drawMapType').value == GeoFilterNext.geoRadius) {
      this.setMap(null, false);
    }
  }

  onValidation() {
    if (this.isEditQuestion) {
      this.setValidation('ageType');
      this.setValidation('segmentType');
      this.setValidation('visitType');
      this.setValidation('filterFromDate');
      this.setValidation('filterToDate');
      this.setValidation('saveType');
      if (this.geofiltereForm.get('locationType').value == GeoFilterNext.geoSite) {
        this.setValidation('geoSite');
        this.removeValidation('drawMapType');
        this.removeValidation('radius');
        this.isGeoMarker = false;
        this.drawMessage = "";
      } else if (this.geofiltereForm.get('locationType').value == GeoFilterNext.customlocation) {
        this.setValidation('drawMapType');
        this.removeValidation('geoSite');
      }

      if (this.geofiltereForm.get('drawMapType').value == GeoFilterNext.drawSite) {
        if (this.geoLatLng == null || this.geoLatLng == '') {
          this.isGeoMarker = true;
          this.drawMessage = "Please draw shape";
        }
      } else if (this.geofiltereForm.get('drawMapType').value == GeoFilterNext.geoRadius) {
        this.setValidation('radius');
        this.removeValidation('geoSite');
        if (this.geoLatLng == null || this.geoLatLng == '') {
          this.isGeoMarker = true;
          this.drawMessage = "Please add marker";
        }
      }

      if (this.geofiltereForm.get('ageType').value == 'yes') {
        this.setValidation('age');
        this.setValidation('ageOperator');
      } else if (this.geofiltereForm.get('ageType').value == 'no') {
        this.removeValidation('age');
        this.removeValidation('ageOperator');
        this.removeValidation('ageRange');
      }

      if (this.geofiltereForm.get('segmentType').value == 'yes') {
        this.setValidation('segOpt');
        this.setValidation('segId');
      } else if (this.geofiltereForm.get('segmentType').value == 'no') {
        this.removeValidation('segOpt');
        this.removeValidation('segId');
      }

      if (this.geofiltereForm.get('visitType').value == 'yes') {
        this.setValidation('visitOperator');
        this.setValidation('visit');
      } else if (this.geofiltereForm.get('visitType').value == 'no') {
        this.removeValidation('visitOperator');
        this.removeValidation('visit');
        this.removeValidation('visitRange');
      }
      if (this.geofiltereForm.get('saveType').value == 'yes') {
        this.setValidation('questionName');
      } else if (this.geofiltereForm.get('saveType').value == 'no') {
        this.removeValidation('questionName');
      }
    }
  }

  onSubmit(form: any) {
    this.onValidation();
    if (!this.geofiltereForm.valid || this.isGeoMarker || this.isExistQuestion) {
      return true;
    }
    this.isSubmitted = 1;
    if (form.locationType == GeoFilterNext.geoSite) {
      form.geoLatLng = "";
      form.radius = "";
    } else if (form.drawMapType == GeoFilterNext.drawSite) {
      form.geoLatLng = this.currentAdd.toGeoJSON().geometry;
    } else if (form.drawMapType == GeoFilterNext.geoRadius) {
      form.geoLatLng = this.geoLatLng;
    }

    if (form.ageType == 'no') {
      form.age = "";
      form.ageOperator = "";
      form.ageRange = "";
    }
    if (form.segmentType == 'no') {
      form.segId = [];
      form.segOpt = "";
    }
    if (form.visitType == 'no') {
      form.visit = "";
      form.visitOperator = "";
      form.visitRange = "";
    }
    if (form.saveType == 'no') {
      form.questionName = "";
    }

    if (form.ageOperator != null && (form.ageOperator != "between" || form.ageOperator != "or"))
      form.ageRange = "";
    if (form.visitOperator != null && (form.visitOperator != "between"))
      form.visitRange = "";

    form.filterFromDate = this.commonService.getDateConverted(form.filterFromDate, "YYYY-MM-DD HH:mm:ss");
    form.filterToDate = this.commonService.getDateConverted(form.filterToDate, "YYYY-MM-DD HH:mm:ss");
    if (this.isEditQuestion) {
      form.saveType = this.savedGeoObj.saveType;
      form._id = this.savedGeoObj._id;
    }
    form.questionId = this.savedGeoObj && this.savedGeoObj.questionId ? this.savedGeoObj.questionId : "";
    delete form.savedQuestionType;
    delete form.savedQuestion;
    let objData = {
      widgetId: this.data.widgetId,
      geoConfig: {
        ...form
      }
    }
    this.widgetService.updateGeoConfig(objData).subscribe(
      res => {
        form.geoFilterType = this.geoFilterType;
        form.mapType = this.data.mapType;
        form.segId = this.data.segId ? this.data.segId : [[]];
        form.segOpt = this.data.segOpt;
        this.widgetService.sendAction("updateGeoConfigModal", { groupId: this.data.groupId, widgetId: this.data.widgetId });
      });
  }
}


// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/geo-map/geo-map.component.ts